<div class="pv-input">
	@if (label) {
		<ic-label [help]="help" [required]="isRequired"> {{ label }} </ic-label>
	}

	<div>
		<input #file type="file" [accept]="accept" [attr.capture]="capture" (change)="onFileSelected(file.files)" />

		@if (!uploaded) {
			@if (uploadTemplate) {
				<ng-template [ngTemplateOutlet]="uploadTemplate" />
			} @else {
				@if (!uploading) {
					<button (click)="selectFile()" (key.enter)="selectFile()">
						{{ placeholder }}
					</button>
				} @else {
					@if (progressTemplate) {
						<ng-template [ngTemplateOutlet]="progressTemplate" [ngTemplateOutletContext]="{ $implicit: progress }" />
					} @else {
						<div class="progress-bar">
							<progress max="100" [value]="progress"></progress> <span> {{ progress }}% </span>
						</div>
					}
				}
			}
		} @else {
			<ul class="files">
				@for (file of files; track file) {
					<li>
						@if (fileTemplate) {
							<ng-template [ngTemplateOutlet]="fileTemplate" [ngTemplateOutletContext]="{ $implicit: file }" />
						} @else {
							<div class="default-template">
								<i class="fa fa-file"> </i> <span> {{ file.filename || file | filename }} </span>
								<i class="fa fa-trash" (click)="reset()"> </i>
							</div>
						}
					</li>
				}
			</ul>
		}

		<ng-content select=".errors" />
	</div>
</div>
